import moment from "moment-jalaali";

export function dateFormat(date) {
  return moment(date).format("jYYYY/jMM/jDD HH:mm");
}
export function getTimeFormat(date) {
  return moment(date).format("HH:mm");
}
export function toJalaali(date) {
  const d = moment(date);

  return {
    year: d.jYear(),
    month: d.jMonth() + 1,
    day: d.jDate(),
  };
}
export function toGregorian(date) {
  if (!date) return;
  const { year, month, day } = date;
  const m = moment(`${year}/${month}/${day}`, "jYYYY/jM/jD");
  return {
    year: m.year(),
    month: m.month(),
    day: m.date(),
  };
}
export function toGregorianDate(date, ...time) {
  const gregorian = toGregorian(date);
  if (!gregorian) return;
  const { year, month, day } = gregorian;
  return new Date(year, month, day, ...time);
}
export function addDays(days, date) {
  var result = date ? new Date(date) : new Date();
  result.setDate(result.getDate() + days);
  return result;
}
